/* src/app/email-campaign/email-campaign-outlook-button/email-campaign-outlook-button.component.scss */
/*# sourceMappingURL=email-campaign-outlook-button.component-IRQIZNQ4.css.map */
